import { NOTIFICATIONS_BREADCRUMB } from "app/constants/breadcrumbs";
import { paths } from "app/constants/paths";

import type { BreadCrumbElement } from "app/components/BreadCrumbsHeader";

/**
 * Breadcrumbs for the consolidated Notifications views. The `tabs` crumb backs
 * both the breadcrumb header (which collapses it to the active tab) and the
 * vertical tab rail rendered by `NotificationsTabsLayout`, keeping the two in
 * sync.
 */
export function useNotificationsBreadcrumbs(): BreadCrumbElement[] {
  return [
    NOTIFICATIONS_BREADCRUMB,
    {
      tabs: [
        { label: "Overview", target: paths.notificationsOverview },
        { label: "Settings", target: paths.notificationsSettings },
        { label: "Rules", target: paths.notificationRules, chip: "preview" },
      ],
    },
  ];
}
